export default Object.freeze({
  total: [],
});
